import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/gymklar';
export function Difference() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-58" data-mp="e3dirvkbfkrm">
      <div className="mx-auto max-w-6xl" data-id="element-59" data-mp="9mg9750515e">
        <header className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-60" data-mp="58z49v7m0e9k">
          <div className="lg:col-span-7" data-id="element-61" data-mp="574iyfsfek4y">
            <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-62" data-mp="3mguja2sg8vy9">Forskjellen med LØPEKLAR™</p>
            <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-63" data-mp="3rgp8m1wktdh7">
              Fra stresset søndagskveld til <em className="text-red-700" data-id="element-64" data-mp="3diqzpc10y993">trygg og forberedt.</em>
            </h2>
          </div>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-65" data-mp="3ihv7by8avyxb">
            Tenk deg å starte uka med fellestreningene allerede organisert. Du vet hva gruppen skal
            løpe – og du har årshjulet, øktkortene, nivåene, sonene og
            løypeskissene klare.
          </p>
        </header>

        <dl className="mt-14 grid border-t border-slate-900/15 sm:grid-cols-3" data-id="element-66" data-mp="1f9k38522lwtu">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`flex flex-col-reverse py-6 sm:pr-8 ${index > 0 ? 'border-t border-slate-900/10 sm:border-l sm:border-t-0 sm:pl-8' : ''}`} data-id="element-67" data-mp="1t1i5px1a0uh1" data-mpi={index}>
              <dt className="mt-1.5 text-sm leading-snug text-slate-900/70" data-id="element-68" data-mp="1o487brvwt8h2">{stat.label}</dt>
              <dd className="font-serif text-3xl leading-tight text-slate-900" data-id="element-69" data-mp="10edx7i2z5y0i">{stat.value}</dd>
            </div>)}
        </dl>

        <div className="mt-14 grid gap-5 lg:grid-cols-2" data-id="element-70" data-mp="1aa7ibpureztw">
          <article className="rounded-3xl border border-slate-900/10 bg-stone-100 p-8 sm:p-11" data-id="element-71" data-mp="1absd9gkzkksa">
            <p className="text-sm font-semibold text-slate-900/60" data-id="element-72" data-mp="15a2xjnmtjixv">Uten LØPEKLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight text-slate-900/80 sm:text-4xl" data-id="element-73" data-mp="2locq6ty3ftui">
              Kjenner du deg igjen?
            </h3>
            <ul className="mt-8 divide-y divide-slate-900/10 border-t border-slate-900/10" data-id="element-74" data-mp="2orisltmi9qtp">
              {beforeItems.map(item => <li key={item.title} className="flex gap-4 py-4 text-[15px] leading-relaxed text-slate-900/70" data-id="element-75" data-mp="2ssaz4f3zthma">
                  <XIcon className="mt-1 h-4 w-4 shrink-0 text-slate-900/40" aria-hidden="true" data-id="element-76" data-mp="2xsyrb43yk4i3" />
                  <span data-id="element-77" data-mp="32pyxdf0t5797">
                    <span className="block font-semibold text-slate-900/80" data-id="element-78" data-mp="32qi7i9k7urco">{item.title}</span>
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl bg-slate-900 p-8 text-stone-50 shadow-2xl shadow-slate-900/30 sm:p-11" data-id="element-79" data-mp="2a2maf3qqixfd">
            <p className="text-sm font-semibold text-red-300" data-id="element-80" data-mp="2ezmhnhzbm682">Med LØPEKLAR™</p>
            <h3 className="mt-2 font-serif text-3xl leading-tight sm:text-4xl" data-id="element-81" data-mp="2jtgxgabt211v">
              Planlegg mindre. Tren mer.
            </h3>
            <ul className="mt-8 divide-y divide-white/10 border-t border-white/10" data-id="element-82" data-mp="1rbldel96dbyg">
              {afterItems.map(item => <li key={item} className="flex gap-4 py-4 text-[15px] leading-relaxed text-stone-50/90" data-id="element-83" data-mp="1jsvoafdskdql">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-84" data-mp="1espogbxdbkxf">
                    <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-85" data-mp="19t4oby6gp6j4" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-14 max-w-2xl text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-86" data-mp="10v14r7f1ejty">
          Fokuser på løperne – ikke på å lage alle øktene selv.
        </p>
      </div>
    </section>;
}